import { useMemo } from 'react';

import { addQueryToUrl, getQueriesFromUrl, removeAllQueries } from 'utils/URLManipulations';
import type { UseCanonicalization } from 'hooks/types';

const useCanonicalization: UseCanonicalization = (absoluteUrl, withPagination, metadata) =>
  useMemo(() => {
    if (withPagination) {
      const { page } = getQueriesFromUrl(absoluteUrl);
      const queryLessUrl = removeAllQueries(absoluteUrl);
      if (page) {
        const canonicalUrl = addQueryToUrl(queryLessUrl, 'page', page);
        const prevPageNumber = String(Number(page) - 1);
        const prevPageUrl =
          prevPageNumber === '1'
            ? queryLessUrl
            : addQueryToUrl(queryLessUrl, 'page', prevPageNumber);
        const nextPageUrl = metadata?.next_page
          ? addQueryToUrl(queryLessUrl, 'page', String(Number(page) + 1))
          : null;
        return [canonicalUrl, prevPageUrl, nextPageUrl];
      }
      const nextPageUrl = metadata?.next_page ? addQueryToUrl(queryLessUrl, 'page', '2') : null;
      return [queryLessUrl, null, nextPageUrl];
    }
    return [removeAllQueries(absoluteUrl), null, null];
  }, [absoluteUrl, withPagination]);

export default useCanonicalization;
